import { useState } from 'react';
import './Blog.scss';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Popup from '../../components/Popup';
import Image from './3.jpg';

const BlogPage = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='page'>
      <Header />
      <div className='blogPageMainScreen'>
        <div className='blogPageMainScreenContent'>
          <span className='blogPageMainScreenBack' onClick={() => navigate('/blog')}>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
              <path
                d='M7.9987 12.6667L3.33203 7.99999M3.33203 7.99999L7.9987 3.33333M3.33203 7.99999H12.6654'
                stroke='#3A6376'
                stroke-width='1.33'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
            Back to Articles
          </span>
          <h1 className='blogPageMainScreenTitle'>No Bad Days: The Benefits of a Positive Attitude in Healthcare</h1>
          <span className='blogPageMainScreenDate'>December 17, 2025</span>
          <div className='blogPageMainScreenImage'>
            <img src={Image} />
          </div>
        </div>
      </div>
      <div className='blogPageContent'>
        <p>
          Let’s face it. No matter what industry a person works in, it’s nearly impossible to maintain a positive attitude 100% of
          the time. The early mornings, long hours, or unpleasant coworkers can be enough to drive someone mad. But the harsh
          reality is, most of us don’t have a choice about whether we have to work or not, so might as well make the most of it!
          If you struggle some days, you’re not alone. To help get through those harder times, we’ve compiled some helpful
          information for healthcare workers.
        </p>
        <h3>The benefits of positivity in the workplace</h3>
        <p>
          <b>Are you allowing negativity to affect your day?</b> Positivity in healthcare can be more important than in other
          careers. You are a caregiver and have the power to make a difference in how your patients feel and recover. They are
          relying on you to help them feel comfortable during a confusing, stressful or even scary point of their lives.
          Expressing compassion and enthusiasm makes a world of difference. Not only is your chosen attitude impacting your
          patients, but you are also impacting your job performance. A positive attitude can help overcome the daily stressors you
          face and assist with creative solutions to problems. Productivity increases, even when you are assigned a
          less-than-appealing task. People with positive demeanors are better able to handle stress and are more constructive in
          difficult situations. These are fundamental characteristics employers look for when considering employees for promotions
          or writing recommendation letters.
        </p>
        <h3>What causes our negative attitudes</h3>
        <p>
          <b>Are you struggling to get along with a coworker? </b> For those of you who are negatively influenced by your work
          environment, try to identify what is at the root of the problem. It is important to isolate the causes of your poor mood
          and find ways to change it. First of all, you don’t have to like everyone, but don’t ever badmouth your colleagues to
          other colleagues. This kind of behavior is bad for your reputation and also feeds the negative attitude you are trying
          to avoid. Take the high road and ‘kill them with kindness.’ If you aren’t forced to work with them, keep your distance.
          If you are, it may be worth sitting down for a conversation.
        </p>
        <p>
          <b>Are you doubting your ability? </b> You may believe healthcare is where you’re supposed to be, but are still in
          search of the perfect fit. Hopefully, you did your homework on the various areas of healthcare and decided on the one
          most interesting to you. If not, you may be disappointed to learn your career expectation was higher than what reality
          brought you. Maybe you didn’t understand the requirements before accepting the job and the end result is a feeling of
          resentment toward your boss, coworkers, or even patients. To overcome the challenge, you’ll have to speak with your boss
          to resolve the issues. Only you will know what adjustments will help ease your doubting.
        </p>
        <h3>Tips to turning a negative outlook around </h3>
        <p>
          <b>Are you burnt out and need a change? </b> It’s normal for a job to become mundane after years and years of
          experience. If you can relate, it doesn’t have to stay that way! Set yourself daily, monthly and/or yearly goals you can
          always strive for. Take a continuing education class or attend a seminar to enhance your expertise. Look for ways to
          improve a process that could benefit your team and determine how to best implement those changes. Finally, talk with
          your boss or HR representative about advancement opportunities or openings in another department. If you are still
          bored, it might be time to dust off the resume and see what else is out there.
        </p>
        <p>
          <b>Are you stressed? </b> Whether you are stressed about something at work or at home, the feeling tends to bleed into
          both environments. Maybe you are experiencing compassion fatigue — the stress that comes from caring too much. Because
          healthcare workers listen to patient stories of fear, pain, and suffering, they can find themselves experiencing similar
          emotions out of empathy. Deal with compassion fatigue by seeking social support, eliminate any feelings of self-blame
          and guilt, and participate in community events. Also, always remember to take care of your mind and body by consistently
          exercising, eating healthy and getting enough sleep. Think of one colleague you love working with. What makes them so
          great to be around? Do they always wear a smile? Are they always happy to help? Make it your goal to be THAT person.
          Your coworkers, boss, organization, and potentially your paycheck will thank you!
        </p>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <Footer />
    </div>
  );
};

export default BlogPage;
